export const NotFound = () => {
  return <div className="notFound">
    {/* Show some 404 not found image or component here */}
    <img src="https://i0.wp.com/saedx.com/blog/wp-content/uploads/2019/01/saedx-blog-featured-70.jpg?fit=1200%2C500&ssl=1" alt="" />
  </div>
};
